<div class="contentBox">
    <!-- Mobile versión -->
    <div class="col-10 parentShowContent">
        <div class="showContent">
            <div class="formNotMethods">
                <img class="soon-logo" src="/assets/images/bnpl/bancolombia/soon-logo.png" alt="soon-logo">
                <div class="infoNotMethods">
                    <p class="infoNotMethods-title">{{ 'alert-bnpl-title' | translation | async }}</p>
                    <br>
                    <article class="infoNotMethods-article">
                        <p class="article-question">{{ limitsMessage | translation | async }}</p>
                    </article>
                </div>
                <button (click)="returnMethods()" class="btnSendEmail">
                    {{ 'return-title' | translation | async }}
                </button>
            </div>
            <div class="containerBanner">
                <img class="banner-logos" src="/assets/images/bnpl/bancolombia/bancolombia-banner.png"
                    alt="banner-logo">
                <img class="banner-logos" src="/assets/images/bnpl/bancolombia/monitored-banner.png"
                    alt="monitored-info">
            </div>
        </div>
    </div>
    <div class="col-10 containerImg">
        <img src="/assets/images/bnpl/bancolombia/bnpl-alert.png" alt="alert-img">
        <div class="formNotMethods">
            <div class="infoNotMethods">
                <p class="infoNotMethods-title">{{ 'alert-bnpl-title' | translation | async }}</p>
                <br>
                <article class="infoNotMethods-article">
                    <p class="article-question">{{ limitsMessage | translation | async }}</p>
                </article>
            </div>
            <button (click)="returnMethods()" class="btnSendEmail">
                {{ 'return-title' | translation | async }}
            </button>
            <div class="bannerDesktop">
                <img class="banner" src="/assets/images/bnpl/bancolombia/bancolombia-banner.png" alt="banner-logo">
            </div>
        </div>
    </div>
</div>